import { ExpenseDetail } from 'pages/finance/ConciliationSourceList/types';
import { createContext } from 'react';

const ExpenseDetailContext = createContext<{
  expense?: ExpenseDetail;
}>({
  expense: undefined,
});

ExpenseDetailContext.displayName = 'ExpenseDetailContext';

export { ExpenseDetailContext };
